import React from "react";

import { ChipProps } from "./Chip.types";
import { isOutlined } from "./lib";
import { useClassNames } from "../../../structure";
import { adjustColor } from "../../../structure/layout/style/lib";
import { IconName } from "../../basic";
import { Icon } from "../../basic/icon";

export default function Chip({ title, classNames, disabled, onPress, onClear, type = "tag", value }: ChipProps) {
  const style = useClassNames(
    classNames
      ? [
          "chip",
          "chipNeutralLighter",
          "chipMedium",
          ...classNames,
          disabled ? (isOutlined(classNames) ? "chipOutlineDisabled" : "chipDisabled") : "",
        ]
      : ["chip", "chipNeutralLighter", "chipMedium", disabled ? "chipDisabled" : ""]
  );
  const [isHovered, setIsHovered] = React.useState(false);
  const nameType = {
    positive: {
      radio: "radio_button_checked",
      checkbox: "check_circle",
    },
    negative: {
      radio: "radio_button_unchecked",
      checkbox: "radio_button_unchecked",
    },
  };
  return (
    <button
      disabled={disabled}
      onMouseOver={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
      onClick={() => {
        onPress && onPress(!value);
      }}
      style={{
        all: "unset",
        ...style,
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor:
          isHovered && !disabled
            ? adjustColor(
                style?.backgroundColor && style.backgroundColor !== "transparent"
                  ? style?.backgroundColor
                  : style?.color || "transparent",
                0.9,
                style?.backgroundColor && style.backgroundColor !== "transparent" ? 1 : 0.05
              )
            : style?.backgroundColor || style?.color || "transparent",
        position: "relative",
        paddingLeft: type === "radio" || type === "checkbox" ? style.paddingTop : style.paddingLeft,
        paddingRight: type === "filter" ? style.paddingTop : style.paddingRight,
      }}
    >
      {type === "radio" || type === "checkbox" ? (
        <Icon
          name={nameType[value ? "positive" : "negative"][type] as IconName}
          color={style.color}
          variant="rounded"
          size={style.fontSize + 4}
        />
      ) : null}
      {title}
      {onClear && type === "filter" ? (
        <Icon name="cancel" color={style.color} size={style.fontSize + 4} onPress={onClear} disabled={disabled} />
      ) : null}
    </button>
  );
}
